import { ElementUIHorizontalAlignment } from 'element-ui/types/component'
import { TableColumnFixedType } from 'element-ui/types/table-column'
import { Button, ButtonBase, ButtonGroup, Tag, Image } from './presets'
import { QueryMethod } from './query'

export type Column<T> = Slot | (ColumnBase<T> & ColumnHeader)

type Slot = { slot: string }
type ColumnBase<T> = {
  prop: keyof T
  hidden?: boolean
  width?: number
  align?: ElementUIHorizontalAlignment
  fixed?: TableColumnFixedType
  /** Set column preset, default is plain text*/
  preset?: Tag | Image | Button | ButtonGroup
  format?: (cell: any) => string | number
}

export function isSlot<T>(column: Column<T>): column is Slot {
  return !!(column as any).slot
}

export type ColumnHeader =
  | { label: string }
  | { label: string; query: QueryConfig }
  | { label: string; button: ButtonBase }

export type QueryConfig = {
  method: QueryMethod
  /** default is column.prop */
  field?: string
  /** If set options, it will be a selector */
  options?: { label: string; value: string | number }[]
}
